import React from "react";
import PropTypes from "prop-types";
import { Subscribe } from "unstated";
import SrpContainer from "../../containers/SrpContainer";
import classes from "./styles.module.scss";
import cl from "classnames";

const Sublocations = ({ sublocations }) => {
  if (sublocations && sublocations.length) {
    return (
      <div className={cl(classes["popular-links"], "strong padded")}>
        <h4>Narrow your search by Location</h4>
        {sublocations.map((location) => (
          <a
            key={location.slug}
            href={`/book-venue-${location.slug}`}
            alt={`Venues is ${location.name}`}
          >
            {location.name}
          </a>
        ))}
      </div>
    );
  }
  return null;
};
Sublocations.propTypes = {
  sublocations: PropTypes.array,
};

const AlsoSearchedFor = ({ alsoSearchedFor }) => {
  if (alsoSearchedFor && alsoSearchedFor.length) {
    return (
      <div className={cl(classes["popular-links"], "strong padded")}>
        <h4>People also searched for</h4>
        {alsoSearchedFor.map((location) => (
          <a href={location.url} key={location.name}>
            {location.name}
          </a>
        ))}
      </div>
    );
  }
  return null;
};
AlsoSearchedFor.propTypes = {
  alsoSearchedFor: PropTypes.array,
};

const Links = ({
  location,
  srps,
  sublocations,
  alsoSearchedFor,
  srpsCounter,
}) => {
  return (
    <div className={cl(classes["links-under-map"])}>
      {alsoSearchedFor && alsoSearchedFor.length ? (
        <AlsoSearchedFor alsoSearchedFor={alsoSearchedFor} />
      ) : null}
      {sublocations && sublocations.length ? (
        <Sublocations sublocations={sublocations} />
      ) : null}
      {srps && srps.length && srpsCounter ? (
        <div className="srps strong padded">
          <h3>Popular searches</h3>
          <div className="ux-row-wrap">
            {srps.map((srp) => {
              // if (!srp.data || srp.data.count <= 5) return null

              if (location.pathname !== srp.url) {
                return (
                  <div
                    className={cl(
                      classes["srp-srps-link"],
                      `background-image square padded-outer min120 max240 srp-srps-link location_${srp.query.location
                        .toLowerCase()
                        .replace(/[^a-z]/gi, "_")} ${srp.query.tagClass}`
                    )}
                    // className={`background-image square centered padded-outer min160 max240 srp-srps-link location_${srp.query.location.toLowerCase().replace(/[^a-z]/gi, '_')} ${srp.query.tagClass}`}
                    key={srp.url}
                  >
                    <a href={srp.chp_tag_url || srp.url}>
                      <span>{srp.srp_name}</span>
                    </a>
                  </div>
                );
              }

              return (
                <div
                  className={`background-image square centered padded-outer min120 max240 srp-srps-link location_city location_${srp.query.location
                    .toLowerCase()
                    .replace(/[^a-z]/gi, "_")}`}
                  key={srp.url}
                >
                  <a
                    href={
                      srp.chp_tag_url ||
                      `/book-venue-${srp.query.location.toLowerCase()}`
                    }
                  >
                    <span>{srp.query.location} Venues</span>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

Links.propTypes = {
  location: PropTypes.object.isRequired,
  srps: PropTypes.array,
  sublocations: PropTypes.array,
  alsoSearchedFor: PropTypes.array,
  srpsCounter: PropTypes.number,
};

const LinksContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({
      state: { srps, alsoSearchedFor, sublocations, srpsCounter, location },
    }) => (
      <Links
        location={location}
        sublocations={sublocations}
        alsoSearchedFor={alsoSearchedFor}
        srps={srps}
        srpsCounter={srpsCounter}
      />
    )}
  </Subscribe>
);

export default LinksContainer;
